export const showAlert = ({ createdDate, lastViewedDate }) => createdDate && lastViewedDate && new Date(createdDate).getTime() >= new Date(lastViewedDate).getTime();



// WEBPACK FOOTER //
// ./src/components/FavNotifications/favNotificationsHelpers.es.js